module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_footer_image_01-871651520e2f1be7f7e9e4ecaac744e1.jpg";